module.exports = __webpack_public_path__ + "logo.563a21b3ae3d5510f283.png";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/images/logo.png
// module id = ../../../../../src/assets/images/logo.png
// module chunks = main